$('.footerserviceslider').owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
    responsive:{
        0:{
            items:2,
            nav:true,
            dots:false
        },
        600:{
            items:3,
            nav:false
        },
        1000:{
            items:4,
            nav:false,
            loop:false,
            dots:false
        }
    }
})
$('.shopbyconcern').owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
    responsive:{
        0:{
            items:3,
            nav:true,
            dots:false
        },
        600:{
            items:3,
            nav:false
        },
        1000:{
            items:4,
            nav:false,
            loop:false,
            dots:true
        }
    }
})
$('.smartblogslider').owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
    responsive:{
        0:{
            items:2,
            nav:true,
            dots:false
        },
        600:{
            items:3,
            nav:false
        },
        1000:{
            items:5,
            loop:false,
            dots:false
        }
    }
})
$('.diagnosisslider').owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
            nav:true,
    responsive:{
        0:{
            items:3,
            nav:true,
            dots:false
        },
        600:{
            items:3,
            nav:false
        },
        1000:{
            items:5,
            loop:false,
            dots:false
        }
    }
})
$('.whattoget').owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
            nav:true,
    responsive:{
        0:{
            items:2,
            nav:true,
            dots:false
        },
        600:{
            items:3,
            nav:false
        },
        1000:{
            items:5,
            loop:false,
            dots:false
        }
    }
})
$('.testimonialslid').owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
            nav:true,
    responsive:{
        0:{
            items:1,
            nav:true,
            dots:false
        },
        600:{
            items:1,
            nav:false
        },
        1000:{
            items:1,
            loop:false,
            dots:false
        }
    }
})

$('.wmptestislider').owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
            nav:false,
  dots:true,
  
    autoplay:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2,
            nav:false
        },
        1000:{
            items:2
        }
    }
})


$('.yogoimageslider').owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
            nav:false,
  autoplay:true,
    autoplayTimeout:2000,
  dots:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1,
            nav:false
        },
        1000:{
            items:1
        }
    }
})

$('.couponcodeslider').owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
            nav:false,
  autoplay:true,
    autoplayTimeout:5000,
  dots:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1,
            nav:false
        },
        1000:{
            items:1
        }
    }
})

const tabButtons = document.querySelectorAll('.tab-button');
const tabContents = document.querySelectorAll('.tab-content');

tabButtons.forEach(button => {
  button.addEventListener('click', () => {
    const tabId = button.getAttribute('data-tab');

    tabButtons.forEach(btn => {
      btn.classList.remove('active');
    });
    button.classList.add('active');

    tabContents.forEach(content => {
      if (content.id === tabId) {
        content.style.display = 'block';
      } else {
        content.style.display = 'none';
      }
    });
  });
});



